export default __webpack_public_path__ + "static/media/x-mark-xxl.b977a8dd.png";